
// cropOptions.js
export const irrigationOptions = [
    "Side Wheel Roll",
    "Hand Move",
    "Pivot - Low Pres. Drops",
    "Pivot - Low Pres. w/ Corner",
    "Pivot - High Pres. Impacts",
    "Pivot - High Pres. w/ Corner",
    "Linear - Low Pres. Drops",
    "Linear - High Pres. Impacts",
    "Other",
  ];